module.exports = __webpack_public_path__ + "static/media/logo.7e6460e0.png";